import { render, staticRenderFns } from "./StatPing.vue?vue&type=template&id=47041317&scoped=true&"
import script from "./StatPing.vue?vue&type=script&lang=js&"
export * from "./StatPing.vue?vue&type=script&lang=js&"
import style0 from "./StatPing.vue?vue&type=style&index=0&id=47041317&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47041317",
  null
  
)

export default component.exports